package com.exura.features.publicplans.data.remote.dto

import com.exura.features.plandefinition.domain.model.PlanContentSummary
import com.exura.features.storage.domain.model.ModelDto
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient

@Serializable
data class PublicPlanServingEntryDto(
    val sharedFrom: String,
    val sharedTo: String?,
    val sharedPlanId: String,
    val summary: PlanContentSummary,
) : ModelDto<PublicPlanServingEntryDto> {
    @Transient
    override val serializer = serializer()
}
